import axios from 'axios';
import { urlBaseEndpoint } from './index';

const endpoint = 'csvexport';

const downloadBlob = (data: Blob, filename: string) => {
	const url = window.URL.createObjectURL(data);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	link.click();
	window.URL.revokeObjectURL(url);
};

export const exportUsersCsv = async (request: Record<string, any>): Promise<void> => {
	const response = await axios({
		method: 'post',
		url: `${urlBaseEndpoint}/${endpoint}/export`,
		data: request,
		withCredentials: true,
		responseType: 'blob',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	const contentDisposition = response.headers['content-disposition'];
	let filename = 'benutzer-export.csv';
	if (contentDisposition) {
		// bevorzugt filename* (RFC 5987), sonst filename — jeweils nur bis zum nächsten ';'
		const extMatch = contentDisposition.match(/filename\*\s*=\s*([^;]+)/i);
		const plainMatch = contentDisposition.match(/filename\s*=\s*("[^"]*"|[^;]+)/i);
		if (extMatch) {
			const value = extMatch[1].trim().replace(/^"|"$/g, '');
			const encoded = value.replace(/^[^']*'[^']*'/, '');
			try {
				filename = decodeURIComponent(encoded);
			} catch {
				filename = encoded;
			}
		} else if (plainMatch) {
			filename = plainMatch[1].trim().replace(/"/g, '');
		}
	}

	downloadBlob(new Blob([response.data], { type: 'text/csv' }), filename);
};

export const downloadSampleCsv = async (): Promise<void> => {
	const response = await axios({
		method: 'get',
		url: `${urlBaseEndpoint}/${endpoint}/sample`,
		withCredentials: true,
		responseType: 'blob',
	});

	downloadBlob(new Blob([response.data], { type: 'text/csv' }), 'benutzer-vorlage.csv');
};

export const importUsersCsv = async (file: File): Promise<any> => {
	const formData = new FormData();
	formData.append('file', file);

	const response = await axios({
		method: 'post',
		url: `${urlBaseEndpoint}/${endpoint}/import`,
		data: formData,
		withCredentials: true,
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});

	return response.data;
};
